// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-single-select optgroup[data-v-177193ef]{color:#eee}.field-single-select .field-content[data-v-177193ef]{display:flex;flex-direction:column}.field-single-select .field-content select[data-v-177193ef]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
